import React, { useState, useEffect } from "react";
import { Box, Card, CardContent, Typography } from '@mui/material';
import { BigGreenSpacedTypography } from "../components/CustomMUI";


const TextPage: React.FC<TextToTypographyProps> = ({ filename }) => {
  return (
    <>
    <Card sx={{margin: '50px'}}>
      <CardContent sx={{padding: {sx: '20px', md: '100px'}}}>
        <TextToTypography filename={ filename }></TextToTypography>
      </CardContent>
    </Card>
    </>
  );
}

interface TextToTypographyProps {
  filename: string;
}

export const TextToTypography: React.FC<TextToTypographyProps> = ({ filename }) => {
  const [text, setText] = useState<string>('');

  useEffect(() => {
    fetch(filename)
      .then(response => response.text())
      .then(data => setText(data));
  }, [filename]);

  if (!text) {
    return <div>Loading...</div>;
  }

  // Split the text into paragraphs by splitting on double line breaks
  const paragraphs = text.split(/\r?\n\r?\n/);

  return (
    <>
      <Box sx={{maxWidth: '726px'}}>
     
      {paragraphs.map((paragraph, index) => {
        const isFirstCharDigit = /^\d/.test(paragraph); // check if first character is a digit
        const hasDecimal = /^\d+\.\d/.test(paragraph); // check if it begins with a decimal number

        if (index === 0 || (isFirstCharDigit && !hasDecimal)) {
          return (
            <BigGreenSpacedTypography key={index} gutterBottom>
              {paragraph}
            </BigGreenSpacedTypography>
          );
        } else if (hasDecimal) {
          return (
            <Typography key={index} variant="h6" gutterBottom sx={{marginBottom: '20px'}}>
              {paragraph}
            </Typography>
          );
        } else {
          return (
            <Typography variant="body1" key={index} gutterBottom sx={{marginBottom: '40px', textAlign: 'justify'}} >
              {paragraph}
            </Typography>
          );
        }
      })}

      </Box>
    </>
  );
};

export default TextPage;

